import { zodValidator } from '@tanstack/zod-adapter';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import {
  PresentationsPage,
  type PresentationsSearch,
} from '../features/presentations/presentations-page';

const SearchSchema = z.object({
  order: z.enum(['asc', 'desc']).catch('desc'),
  page: z.number().int().positive().catch(1),
  pageSize: z.union([z.literal(10), z.literal(25), z.literal(50), z.literal(100)]).catch(25),
  search: z.string().trim().max(200).optional().catch(undefined),
  sort: z.enum(['name', 'updatedAt']).catch('updatedAt'),
  status: z.enum(['DRAFT', 'IN_REVIEW', 'APPROVED', 'PUBLISHED']).optional().catch(undefined),
  updated: z.enum(['7d', '30d', '90d']).optional().catch(undefined),
  view: z.enum(['grid', 'list']).optional().catch(undefined),
});

export const Route = createFileRoute('/manage/$companySlug/projects/$projectId/presentations/')({
  component: RouteComponent,
  validateSearch: zodValidator(SearchSchema),
});

function RouteComponent() {
  const { companySlug, projectId } = Route.useParams();
  const search: PresentationsSearch = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <PresentationsPage
      companySlug={companySlug}
      onFiltersChange={(patch) =>
        void navigate({ search: (previous) => ({ ...previous, ...patch, page: 1 }) })
      }
      onPageChange={(page) => void navigate({ search: (previous) => ({ ...previous, page }) })}
      onSearchChange={(value) =>
        void navigate({
          replace: true,
          search: (previous) => ({ ...previous, page: 1, search: value }),
        })
      }
      projectId={projectId}
      search={search}
    />
  );
}
